import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useT } from "@/i18n/i18n";
import { useAuth, formatApiError } from "@/context/AuthContext";
import { Logo, LanguageSwitcher } from "@/components/shared";
import { Field, Input, Btn } from "@/pages/app/kit";
import { toast } from "sonner";
import api from "@/lib/api";

export default function Login() {
  const { t } = useT();
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [demo, setDemo] = useState({ enabled: false, accounts: [], password: null });

  useEffect(() => { api.get("/public/demo-info").then((r) => setDemo(r.data)).catch(() => {}); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("OK");
      nav("/app");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  const quick = (em) => { setEmail(em); if (demo.password) setPassword(demo.password); };

  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <div className="hidden bg-forestdark p-10 lg:flex lg:flex-col lg:justify-between">
        <Logo light />
        <div>
          <h2 className="font-heading text-3xl font-bold text-white">{t("slogan")}</h2>
          <p className="mt-4 max-w-md text-white/70">{t("home.doctrine")}</p>
        </div>
        <div className="text-xs text-white/40">© {new Date().getFullYear()} Żywiąca Polska · Hussar Holdings LLC</div>
      </div>
      <div className="flex flex-col justify-center px-6 py-12 sm:px-12">
        <div className="mx-auto w-full max-w-sm">
          <div className="mb-6 flex items-center justify-between lg:hidden"><Logo /><LanguageSwitcher light={false} /></div>
          <h1 className="font-heading text-2xl font-bold text-charcoal">{t("auth.loginTitle")}</h1>
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="login-form">
            <Field label={t("auth.email")} required><Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required /></Field>
            <Field label={t("auth.password")} required><Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required /></Field>
            <Btn type="submit" className="w-full" disabled={busy} data-testid="login-submit">{busy ? "…" : t("auth.loginTitle")}</Btn>
          </form>
          <p className="mt-4 text-sm text-mutedtext">{t("auth.noAccount")} <Link to="/register" className="font-semibold text-forest">{t("nav.register")}</Link></p>

          {demo.enabled && (
          <div className="mt-8 rounded-md border border-subtle bg-white p-4">
            <div className="text-xs font-semibold uppercase tracking-wide text-mutedtext">{t("auth.demoAccounts")}</div>
            <div className="mt-2 space-y-1">
              {demo.accounts.map((a) => (
                <button key={a.email} onClick={() => quick(a.email)} data-testid={`demo-${a.label.toLowerCase().replace(/[^a-z]/g, "")}`} className="flex w-full items-center justify-between rounded px-2 py-1.5 text-left text-sm hover:bg-secondary">
                  <span className="text-charcoal">{a.label}</span><span className="text-xs text-mutedtext">{a.email}</span>
                </button>
              ))}
              {demo.password && <div className="pt-1 text-xs text-mutedtext">{t("auth.password")}: <span className="font-mono" data-testid="demo-password">{demo.password}</span></div>}
            </div>
          </div>
          )}
        </div>
      </div>
    </div>
  );
}
